import { IonButtons, IonHeader, IonImg, IonProgressBar, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router';

import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import { IconRotate } from '@/components/Icon/types';

import { mergeClassNames } from '@/utils/mergeClassNames';

import BackgroundPattern from '@/assets/bg-pattern-pageheader.png';

import styles from './PageHeader.module.css';

import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';

interface PageHeaderProps extends ComponentProps<typeof IonHeader> {
  backTarget?: string;
  isLoading?: boolean;
  progress?: number;
  title?: string;
  topSlot?: ReactNode;
  toolbarClassName?: string;
  onBack?: VoidFunction;
}

export const PageHeader = ({
  children,
  title,
  backTarget,
  isLoading,
  progress,
  topSlot,
  className,
  toolbarClassName,
  onBack,
  ...props
}: PropsWithChildren<PageHeaderProps>) => {
  const history = useHistory();

  const goBack = (backTarget: string) => {
    onBack?.();
    history.push(backTarget);
  };

  return (
    <IonHeader {...props} className={mergeClassNames('ion-no-padding', styles.header, className)}>
      {topSlot}

      <IonToolbar className={mergeClassNames(styles.toolbar, topSlot && styles.withTopSlot, toolbarClassName)}>
        {backTarget && !isLoading && (
          <IonButtons slot='start'>
            <Button className={styles.backButton} onClick={() => goBack(backTarget)} variant='tertiary'>
              <Icon direction={IconRotate.West} name='chevron' size={13} />
              Back
            </Button>
          </IonButtons>
        )}

        {children ?? <IonTitle>{title}</IonTitle>}

        {isLoading && (
          <IonProgressBar
            className={styles.progress}
            type={progress === undefined ? 'indeterminate' : 'determinate'}
            value={progress}
          />
        )}
      </IonToolbar>

      <IonImg className={styles.background} src={BackgroundPattern} />
    </IonHeader>
  );
};
